import store from "../store";
import { PRODUCT_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class ProductClass {
  constructor() {}

  public getProductCategories = async () => {
    try {
      const data = {
        endpoint: `products/product-categories`,
      };

      const categories = await DatabaseInstance.getRecord(data);

      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            categories,
          },
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  public getProductSubCategories = async (categoryId: string | number | undefined) => {
    try {
      const data = {
        endpoint: `product-categories/get-sub-types/${categoryId}`,
      };

      const subCategories = await DatabaseInstance.getRecord(data);

      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            subCategories,
          },
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };
}

const ProductInstance = new ProductClass();

export { ProductInstance };
